import { AppShell, PageHeader, PageTitle } from '@/components/layout';

export function PlaceholderPage({ title }: { title: string }) {
  return (
    <AppShell>
      <main className="content">
        <PageHeader subtitle="Esta tela ainda não tem referência visual." />
        <PageTitle title={title} />
        <p className="subtitle">Em breve.</p>
      </main>
    </AppShell>
  );
}
